import { useEffect } from "react"
import { FaDoorClosed, FaTrash } from "react-icons/fa"
import { useSelector } from "react-redux"
import { setRemoveCardVerification } from "../store/cards.dispatch"
import { removeItem } from "localforage"


const MyAlertDialog = () => {

  const cardId = useSelector(state => state.cards.removeCardVerification.cardId)
  const toBeRemoved = useSelector(state => state.cards.removeCardVerification.toBeRemoved)

  const removeAndRefresh = async () => {
    await removeItem({ id: cardId });
    alert('removed');
  }

  return (
    <dialog
      id="removeCardVerificationDialog"
      className="modal"
    >
      <div className="modal-box">
        <h3 className="font-bold text-lg">Hello!</h3>
        <p className="py-4">Press ESC key or click the button below to close {cardId}</p>
        <div className="modal-action">
          <form method="dialog">
            <button
              className="btn btn-error"
              onClick={removeAndRefresh}
            >                
              <FaTrash /> Remove
            </button>
            <button
              className="btn">
              <FaDoorClosed /> Close
            </button>
          </form>
        </div>
      </div>
    </dialog >
  )
}

export const RemoveCardDialog = () => {

  const cardId = useSelector(state => state.cards.removeCardVerification.cardId)
  const toBeRemoved = useSelector(state => state.cards.removeCardVerification.toBeRemoved)

  useEffect(() => {
    if (cardId && toBeRemoved) {
      document.getElementById('removeCardVerificationDialog').showModal()
    }
  }, [cardId, toBeRemoved]);
  return (
    <MyAlertDialog />
  )
}

export const RemoveDialogButton = ({ cardId }) => {
  return (<div
    className="fixed top-2 right-2"
    onClick={() => setRemoveCardVerification({
      cardId,
      toBeRemoved: true
    })}
  >
    <FaTrash />
  </div>
  )
}